import { graphql, useStaticQuery } from 'gatsby';

const useFooterIWFSection = () => {
  const { iwfdata } = useStaticQuery(graphql`
            query {
                iwfdata: contentfulAsset(title: {eq: "Internet Watch Foundation Abbreviated Logo"}) {
                  gatsbyImageData
                  file {
                    fileName
                    url
                    contentType
                  }
                  gatsbyImage
                  svg {
                    content
                  }
                }
            }
            `
  );
  return iwfdata;
};

export default useFooterIWFSection;